import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';

export const MODULE_ACCESS_FEATURE_KEY = 'moduleAccess';

export interface ModuleAccessState {
  /**
   * Workspace-level enabled modules ({ app: [modules] }). `null` means the
   * config has not been loaded / does not exist — consumers treat that as
   * "show everything" (fail-open).
   */
  enabledModules: Record<string, string[]> | null;
  updatedAt?: string;
  isLoaded: boolean;
}

export const initialModuleAccessState: ModuleAccessState = {
  enabledModules: null,
  updatedAt: undefined,
  isLoaded: false,
};

export const moduleAccessSlice = createSlice({
  name: MODULE_ACCESS_FEATURE_KEY,
  initialState: initialModuleAccessState,
  reducers: {
    setModuleAccessConfig(
      state,
      action: PayloadAction<{
        enabledModules: Record<string, string[]> | null;
        updatedAt?: string;
      }>
    ) {
      state.enabledModules = action.payload.enabledModules;
      state.updatedAt = action.payload.updatedAt;
      state.isLoaded = true;
    },
    clearModuleAccessConfig() {
      return initialModuleAccessState;
    },
  },
});

export const moduleAccessReducer = moduleAccessSlice.reducer;

export const { setModuleAccessConfig, clearModuleAccessConfig } =
  moduleAccessSlice.actions;

const getModuleAccessState = (rootState: RootState): ModuleAccessState =>
  rootState[MODULE_ACCESS_FEATURE_KEY];

export const getEnabledModules = createSelector(
  getModuleAccessState,
  (state) => state?.enabledModules ?? null
);

export const getIsModuleAccessLoaded = createSelector(
  getModuleAccessState,
  (state) => state?.isLoaded ?? false
);
